import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer>
      <div className="inner flex justify-center wrap">
        <div className="col">
          <img
            src="https://res.cloudinary.com/qaz2dc/image/upload/v1690305330/ucbraids/UC_Braids_rujwoz.png"
            alt="UC Braids"
          />
          <div className="socials flex justify-center align-center">
            <a
              href="https://www.instagram.com/ucbraids/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* <FaInstagram /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 2500 2500"
                className="instagram"
              >
                <g>
                  <defs>
                    <radialGradient
                      id="0"
                      cx="332.14"
                      cy="2511.81"
                      r="3263.54"
                      gradientUnits="userSpaceOnUse"
                    >
                      {/*stopColor="#fa8f21"*/}
                      <stop offset="0.09" className="orange"></stop>
                      {/* stopColor="#d82d7e" */}
                      <stop offset="0.78" className="pink"></stop>
                    </radialGradient>
                    <radialGradient
                      id="1"
                      cx="1516.14"
                      cy="2623.81"
                      r="2572.12"
                      gradientUnits="userSpaceOnUse"
                    >
                      {/* stopColor="#8c3aaa" */}
                      <stop
                        offset="0.64"
                        className="purple"
                        stopOpacity="0"
                      ></stop>
                      {/* stopColor="#8c3aaa" */}
                      <stop offset="1" className="purple"></stop>
                    </radialGradient>
                  </defs>
                  <path
                    fill="url(#0)"
                    d="M833.4 1250c0-230.11 186.49-416.7 416.6-416.7s416.7 186.59 416.7 416.7-186.59 416.7-416.7 416.7-416.6-186.59-416.6-416.7m-225.26 0c0 354.5 287.36 641.86 641.86 641.86s641.86-287.36 641.86-641.86S1604.5 608.14 1250 608.14 608.14 895.5 608.14 1250m1159.13-667.31a150 150 0 10150.06-149.94h-.06a150.07 150.07 0 00-150 149.94M745 2267.47c-121.87-5.55-188.11-25.85-232.13-43-58.36-22.72-100-49.78-143.78-93.5s-70.88-85.32-93.5-143.68c-17.16-44-37.46-110.26-43-232.13-6.06-131.76-7.27-171.34-7.27-505.15s1.31-373.28 7.27-505.15c5.55-121.87 26-188 43-232.13 22.72-58.36 49.78-100 93.5-143.78s85.32-70.88 143.78-93.5c44-17.16 110.26-37.46 232.13-43 131.76-6.06 171.34-7.27 505-7.27s373.28 1.31 505.15 7.27c121.87 5.55 188 26 232.13 43 58.36 22.62 100 49.78 143.78 93.5s70.78 85.42 93.5 143.78c17.16 44 37.46 110.26 43 232.13 6.06 131.87 7.27 171.34 7.27 505.15s-1.21 373.28-7.27 505.15c-5.55 121.87-25.95 188.11-43 232.13-22.72 58.36-49.78 100-93.5 143.68s-85.42 70.78-143.78 93.5c-44 17.16-110.26 37.46-232.13 43-131.76 6.06-171.34 7.27-505.15 7.27s-373.28-1.21-505-7.27M734.65 7.57c-133.07 6.06-224 27.16-303.41 58.06C349 97.54 279.38 140.35 209.81 209.81S97.54 349 65.63 431.24c-30.9 79.46-52 170.34-58.06 303.41C1.41 867.93 0 910.54 0 1250s1.41 382.07 7.57 515.35c6.06 133.08 27.16 223.95 58.06 303.41 31.91 82.19 74.62 152 144.18 221.43S349 2402.37 431.24 2434.37c79.56 30.9 170.34 52 303.41 58.06C868 2498.49 910.54 2500 1250 2500s382.07-1.41 515.35-7.57c133.08-6.06 223.95-27.16 303.41-58.06 82.19-32 151.86-74.72 221.43-144.18s112.18-139.24 144.18-221.43c30.9-79.46 52.1-170.34 58.06-303.41 6.06-133.38 7.47-175.89 7.47-515.35s-1.41-382.07-7.47-515.35c-6.06-133.08-27.16-224-58.06-303.41-32-82.19-74.72-151.86-144.18-221.43S2150.95 97.54 2068.86 65.63c-79.56-30.9-170.44-52.1-303.41-58.06C1632.17 1.51 1589.56 0 1250.1 0S868 1.41 734.65 7.57"
                  ></path>
                  <path
                    fill="url(#1)"
                    d="M833.4 1250c0-230.11 186.49-416.7 416.6-416.7s416.7 186.59 416.7 416.7-186.59 416.7-416.7 416.7-416.6-186.59-416.6-416.7m-225.26 0c0 354.5 287.36 641.86 641.86 641.86s641.86-287.36 641.86-641.86S1604.5 608.14 1250 608.14 608.14 895.5 608.14 1250m1159.13-667.31a150 150 0 10150.06-149.94h-.06a150.07 150.07 0 00-150 149.94M745 2267.47c-121.87-5.55-188.11-25.85-232.13-43-58.36-22.72-100-49.78-143.78-93.5s-70.88-85.32-93.5-143.68c-17.16-44-37.46-110.26-43-232.13-6.06-131.76-7.27-171.34-7.27-505.15s1.31-373.28 7.27-505.15c5.55-121.87 26-188 43-232.13 22.72-58.36 49.78-100 93.5-143.78s85.32-70.88 143.78-93.5c44-17.16 110.26-37.46 232.13-43 131.76-6.06 171.34-7.27 505-7.27s373.28 1.31 505.15 7.27c121.87 5.55 188 26 232.13 43 58.36 22.62 100 49.78 143.78 93.5s70.78 85.42 93.5 143.78c17.16 44 37.46 110.26 43 232.13 6.06 131.87 7.27 171.34 7.27 505.15s-1.21 373.28-7.27 505.15c-5.55 121.87-25.95 188.11-43 232.13-22.72 58.36-49.78 100-93.5 143.68s-85.42 70.78-143.78 93.5c-44 17.16-110.26 37.46-232.13 43-131.76 6.06-171.34 7.27-505.15 7.27s-373.28-1.21-505-7.27M734.65 7.57c-133.07 6.06-224 27.16-303.41 58.06C349 97.54 279.38 140.35 209.81 209.81S97.54 349 65.63 431.24c-30.9 79.46-52 170.34-58.06 303.41C1.41 867.93 0 910.54 0 1250s1.41 382.07 7.57 515.35c6.06 133.08 27.16 223.95 58.06 303.41 31.91 82.19 74.62 152 144.18 221.43S349 2402.37 431.24 2434.37c79.56 30.9 170.34 52 303.41 58.06C868 2498.49 910.54 2500 1250 2500s382.07-1.41 515.35-7.57c133.08-6.06 223.95-27.16 303.41-58.06 82.19-32 151.86-74.72 221.43-144.18s112.18-139.24 144.18-221.43c30.9-79.46 52.1-170.34 58.06-303.41 6.06-133.38 7.47-175.89 7.47-515.35s-1.41-382.07-7.47-515.35c-6.06-133.08-27.16-224-58.06-303.41-32-82.19-74.72-151.86-144.18-221.43S2150.95 97.54 2068.86 65.63c-79.56-30.9-170.44-52.1-303.41-58.06C1632.17 1.51 1589.56 0 1250.1 0S868 1.41 734.65 7.57"
                  ></path>
                </g>
              </svg>
            </a>
          </div>
        </div>
        <div className="col">
          <h3>Categories</h3>
          <ol>
            <li>
              <Link to="/services/small">Small</Link>
            </li>
            <li>
              <Link to="/services/medium">Medium</Link>
            </li>
            <li>
              <Link to="/services/large">Large</Link>
            </li>
            <li>
              <Link to="/services/tribal-braids">Tribal Braid</Link>
            </li>
            <li>
              <Link to="/services/men">Men</Link>
            </li>
            <li>
              <Link to="/services/kids">Kids</Link>
            </li>
            <li>
              <Link to="/services/locs">Locs</Link>
            </li>
            <li>
              <Link to="/services/miscellaneous">Miscellaneous</Link>
            </li>
          </ol>
        </div>
        <div className="col">
          <h3>Hours</h3>
          <div className="grid">
            <p>Sunday:</p>
            <p>2:00 PM - 11:45 PM</p>
            <p>Monday:</p>
            <p>Closed</p>
            <p>Tuesday:</p>
            <p>Closed</p>
            <p>Wednesday:</p>
            <p>Closed</p>
            <p>Thursday:</p>
            <p>Closed</p>
            <p>Friday:</p>
            <p>6:00 PM - 11:45 PM</p>
            <p>Saturday:</p>
            <p>8:00 AM - 11:45 PM</p>
          </div>
        </div>
        <div className="col">
          <h3>Address</h3>
          <a
            href="https://maps.google.com/maps?q=Eagle%20Mountain%2C%20UT%2C%2084043"
            target="_blank"
            rel="noopener noreferrer"
          >
            Eagle Mountain, UT 84043
          </a>
          <h3>Contact</h3>
          <a href="tel:+19138323910">+1 913-832-3910</a>
        </div>
      </div>
      <div className="copy">
        <a
          href="https://roni-egbu.vercel.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          &copy;Roni Egbu
        </a>
      </div>
    </footer>
  );
}

export default Footer;
